import SalesOrderViewStore from "./SalesOrderViewStore";
import QuoteGenerationViewStore from "./QuoteGenerationViewStore";
import SalesOrderConversionViewStore from "./SalesOrderConversionViewStore";

const purchasingStoreList = [
  { name: "salesOrderViewStore", store: SalesOrderViewStore },
  { name: "quoteGenerationViewStore", store: QuoteGenerationViewStore },
  { name: "salesOrderConversionViewStore", store: SalesOrderConversionViewStore },
];

export default purchasingStoreList;
